import { IAdministrationState } from './administrationState';
import { All as Actions } from './administrationActions';
import { AdministrationConstants } from './administrationConstants';

const initialState: IAdministrationState = {
  selectedTab: 0,
};

export function administration(
  state = initialState,
  action: Actions,
): IAdministrationState {
  switch (action.type) {
    case AdministrationConstants.SET_ACTIVE_TAB: {
      return {
        ...state,
        selectedTab: action.payload,
      };
    }
    default:
      return state;
  }
}
